export default function () {
  return [
    // Dashboard
    {
      isCustomer: false,
      title: 'Painel de controle',
      name: 'dashboard',
      to: {
        name: 'admin-overview',
      },
      htmlBefore: '<i class="material-icons">edit</i>',
    },
    // Customer
    {
      title: 'Clientes',
      name: 'customers',
      htmlBefore: '<i class="material-icons">person</i>',
      to: {
        name: 'admin-customer-list',
        params: {
          page: 1,
        },
      },
      items: [
        {
          isCustomer: false,
          title: 'Lista',
          to: {
            name: 'admin-customer-list',
            params: {
              page: 1,
            },
          },
        },
        {
          isCustomer: false,
          title: 'Adicionar',
          href: '/admin/clientes/novo',
          to: {
            name: 'admin-customer-new',
          },
        },
      ],
    },
    // Products
    {
      title: 'Agentes',
      name: 'products',
      htmlBefore: '<i class="material-icons">science</i>',
      to: {
        name: 'admin-product-list',
        params: {
          page: 1,
        },
      },
      items: [
        {
          title: 'Lista',
          to: {
            name: 'admin-product-list',
            params: {
              page: 1,
            },
          },
        },
        {
          title: 'Adicionar',
          to: {
            name: 'admin-product-new',
          },
        },
      ],
    },
    // Services
    {
      title: 'Custos',
      name: 'services',
      htmlBefore: '<i class="material-icons">paid</i>',
      to: {
        name: 'admin-service-list',
        params: {
          page: 1,
        },
      },
      items: [
        {
          title: 'Lista',
          to: {
            name: 'admin-service-list',
            params: {
              page: 1,
            },
          },
        },
        {
          title: 'Adicionar',
          to: {
            name: 'admin-service-new',
          },
        },
      ],
    },
    // Quotation
    {
      title: 'Orçamentos',
      name: 'quotations',
      htmlBefore: '<i class="material-icons">note_add</i>',
      to: {
        name: 'admin-quotation-list',
        params: {
          page: 1,
        },
      },
      items: [
        {
          title: 'Lista',
          to: {
            name: 'admin-quotation-list',
            params: {
              page: 1,
            },
          },
        },
        {
          title: 'Adicionar',
          href: '/admin/orcamentos/novo',
          to: {
            name: 'admin-quotation-new',
          },
        },
      ],
    },
    // Sample
    {
      title: 'Amostragens',
      name: 'samples',
      htmlBefore: '<i class="material-icons">biotech</i>',
      to: {
        name: 'admin-sample-list',
        params: {
          page: 1,
        },
      },
    },
    // User
    {
      title: 'Usuários',
      name: 'users',
      to: {
        name: 'admin-user-list',
        params: {
          page: 1,
        },
      },
      htmlBefore: '<i class="material-icons">perm_identity</i>',
      items: [
        {
          title: 'Lista',
          to: {
            name: 'admin-user-list',
            params: {
              page: 1,
            },
          },
        },
        {
          title: 'Adicionar',
          to: {
            name: 'admin-user-new',
          },
        },
      ],
    },
  ];
}
